import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/lib/components/Section';

import Hero from '../../common/components/Hero';
import HeaderContainer from '../../common/components/HeaderContainer';
import Footer from '../../common/components/Footer';
import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import AppBanner from '../../common/components/AppBanner';

import HiwGuarentee from './components/HiwGuarentee';
import HiwContent from './components/HiwContent';

// Styles
import './../../common/scss/init.scss';

const HowItWorksContainer = () => (
  <div>
    <Hero
      menu={
        <HeaderContainer
          options={['list-your-property', 'favorites']}
          tracking="ga-how-it-works"
        />
      }
      title={trans('how_it_works.alt.hero.title')}
      subtitle={trans('how_it_works.alt.hero.subtitle')}
      backgroundImage={`url(${getResourcePath(
        '/images/how-it-works/how-it-works-header.jpg'
      )})`}
    />

    <Section background="light">
      <HiwContent />
    </Section>

    <Section background="skin">
      <HiwGuarentee />
    </Section>

    <Footer />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default HowItWorksContainer;
